import {
    resetFormValues,
    setError,
    setIsCreateCertificateModalOpen,
} from "../../CreateCertificateModalSlice";
import { JSX, useEffect } from "react";
import { Popup, Sections } from "@hatch-digital-nl/abs-storybook/legacy";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { setFormFields } from "../../utils/setFormFields";
import { calculateExpiresAt } from "../../utils/calculateExpiresAt";
import { getSections } from "../../utils/getSections";
import { SectionEnum } from "../../../../common/enums/SectionEnum";
import { PersonsCertificateForm } from "../../components/Forms/PersonsCertificateForm";
import { EstablishmentCertificateForm } from "../../components/Forms/EstablishmentCertificateForm";
import { OutsourcedForm } from "../../components/Forms/OutsourcedForm";

export const EstablishmentManagerGeneralCreateForm = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const {
        selectedQualification,
        selectedEmployee,
        formValues,
        error,
        section,
    } = useAppSelector((state) => state.createCertificateModal);

    useEffect(() => {
        setFormFields({
            selectedEmployee,
            selectedQualification,
            dispatch,
        });
    }, [selectedQualification, selectedEmployee, dispatch]);

    useEffect(() => {
        calculateExpiresAt({
            formValues,
            dispatch,
        });
    }, [
        formValues?.validAt,
        formValues?.qualification?.validityPeriod,
        formValues?.qualification?.validityType,
        formValues?.qualification?.fixedValidUntil,
        formValues?.expiresAt,
        formValues,
        dispatch,
    ]);

    return (
        <Popup
            className={"c-create-certificate-modal"}
            title={"Certificaat toevoegen"}
            onCloseClick={() => {
                dispatch(setError(null));
                dispatch(resetFormValues());
                dispatch(setIsCreateCertificateModalOpen(false));
            }}
        >
            <Sections
                activeIndex={section.activeIndex}
                sections={getSections(dispatch)}
            />
            {error && <div className={"c-error"}>{error}</div>}

            {section.name === SectionEnum.PERSONS_CERTIFICATE && (
                <PersonsCertificateForm />
            )}

            {section.name === SectionEnum.ESTABLISHMENTS_CERTIFICATE && (
                <EstablishmentCertificateForm />
            )}

            {section.name === SectionEnum.OUTSOURCED && <OutsourcedForm />}
        </Popup>
    );
};
